import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Tooltip, IconButton, InputBase } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseAdvertismentGroup } from "./UseAdvertismentGroup";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

export default function AdvertismentGroup() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const { getGroupList, deleteGroup, updateGroup } = UseAdvertismentGroup();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("RowIndex");
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  const [groupRes, setGroupRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getGroupList(
      myPc,
      search,
      (groups) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(groups.pageCondition.totalPage);
          return;
        }
        setGroupRes(groups);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/advertismentgroup/addgroup", {
      state: {
        myPc: myPc,
        search: search,
        items: groupRes.items,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "rowIndex",
      headerName: "ردیف",
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 250,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "عملیات",
      sortable: false,
      width: 150,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            <Tooltip title="Delete">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());

                  return navigate("/advertismentgroup/editgroup", {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  title: cellValues.row.title,
                  rowIndex: cellValues.row.rowIndex - 1,
                };
                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  setProgress(true);
                  updateGroup(model, () => {
                    getGroupList(
                      myPc,
                      search,
                      (groups) => {
                        if (msGotoLast) {
                          setMsGotoLast(false);
                          goToLastPage(groups.pageCondition.totalPage);
                          return;
                        }
                        setGroupRes(groups);
                      },
                      false
                    );
                  });
                }
              }}
            >
              <ArrowUpwardIcon fontSize="small" />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  title: cellValues.row.title,
                  rowIndex: cellValues.row.rowIndex + 1,
                };
                if (
                  cellValues.row.rowIndex + 1 ==
                  groupRes?.items?.length + 1
                ) {
                  return;
                } else {
                  setProgress(true);
                  updateGroup(model, () => {
                    getGroupList(
                      myPc,
                      search,
                      (groups) => {
                        if (msGotoLast) {
                          setMsGotoLast(false);
                          goToLastPage(groups.pageCondition.totalPage);
                          return;
                        }
                        setGroupRes(groups);
                      },
                      false
                    );
                  });
                }
              }}
            >
              <ArrowDownwardIcon fontSize="small" />
            </IconButton>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "تبلیغات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/advertismentgroup" }],
      }}
    >
      {groupRes ? (
        <DataGrid
          className="ltr-grid"
          disableVirtualization
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={groupRes.pageCondition.pageCount}
          rows={groupRes.items}
          paginationMode="server"
          page={groupRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={groupRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              newFunc: newFunc,
              isLtr: true,
              rowCount: groupRes.pageCondition.totalItemCount,
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"گروه"}
        callback={() => {
          setProgress(true);
          deleteGroup(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
